export default "__VITE_ASSET__CWLDZaVD__"